export const en = {
  translations: {
    title0_1: "Welcome to",
    title0_2: "the ",
    title0_3: "world of industry 4.0",
    checkOurOffer0_1: "Check our ",
    checkOurOffer0_2: "offer",
    checkOurOffer0_3: " below!",
    st1_0_title_1: `Virtual`,
    st1_0_title_2: `Diagnostic Models`,
    st1_0: "Universal virtual models system for dentists.",
    st1_1: "Compatibility with intra-oral scanner and impression.",
    st1_2: `Complete diagnostic information inside the model. \n`,
    st1_3: "Platform for CAD/CAM processing.",

    section_title_2: 'Virtual Diagnostic Models',
    title1_0: 'Virtual Diagnostic Models system for dentists. Diagnostic information inside the model file.',
    title1_1: 'Three types available, adjusted to specific tasks.',
    bt1_0_0: "",
    bt1_0: "DDP-Ortho",
    bt1_1:
      " diagnostic model system allows to keep all important information about the patient in one place.",
    bt1_2: " One patient = one file.",
    bt1_3: " 3D model includes of anatomical details used by ",
    bt1_4: "DDP-Ortho",
    bt1_5:
      " application for automating most important orthodontic analysis of models.",
    bt1_6: "Basic type: full anasysic, pictures, notes",
    bt1_7: "SemiPro type: virtual set-up ready",
    bt1_8: "Pro type: real image of root shapes",
    bt1_9: "Models are used with free ",
    bt1_10: "DDP-Ortho ",
    bt1_11: "software are compatible with ",
    bt1_12: "DDS-Pro ",
    bt1_13: "and ",
    bt1_14: "Ortonet",
    bt1_14_1: ' software.',
    bt1_15_0: "",
    bt1_15: "DDP-Ortho ",
    bt1_16: "models are dedicated for:",
    bt1_17: "Diagnostic Patient file,",
    bt1_18: "Bracket placement planning,",
    bt1_19: "Planning and visualization of treatment options,",
    bt1_20: "Aligner treatment planning,",
    bt1_21: "Surgery / implant treatment planning.",
    bt1_22_1: "DDP-Ortho",
    bt1_22: " models can be ordered in specialized laboratory or prepared in-house using Digital Technical Studio software.",
    bt1_23_0: '',
    bt1_23_1: 'DDP-Ortho',
    bt1_23: ' models can be prepared from impression / plaster model or digital impression (intra-oral scanner) file.',


    section_title_1: 'DDP-Ortho Software',
    title2_0: 'Free, CE certified software for specialists.',
    title2_1: 'Complete Digital orthodontic patient file. Automatic model analysis, cephalometry.',
    title2_2: 'Virtual set-up, treatment visualization. Indirect bonding jigs, aligner treatment planning.',
    st2_0: "Free, CE-certified software for dentists.",
    st2_1: "Digital orthodontic patient file with diagnostic. ",
    st2_2: "Automatic model analysis, cephalometry, ",
    st2_3: "virtual set-up, aligner treatment planning",
    bt2_0: "DDP-Ortho",
    bt2_1: " software is a complete solution for orthodontic practicies.",
    bt2_2: "All components of digital patient file are available.",
    bt2_3: "Based on ",
    bt2_4: "DDP-Ortho ",
    bt2_5: "virtual diagnostic model the software offers:",
    bt2_6: "automatic model analysis,",
    bt2_7: "free measurements,",
    bt2_8: "picture storage with editor,",
    bt2_9: "text notes,",
    bt2_10: "virtual set-up with treatment options visualization,",
    bt2_11: "articulator,",
    bt2_12: "customable cephalometry analysis,",
    bt2_13: "related services like:",
    bt2_14:
      "bracket placement planning with indirect bonding tray production,",
    bt2_15: "complete technical solution of aligner treatment,",
    bt2_16:
      "patient data exchange platform between specialists like orthodontists, implantologists, surgeons, prosthetists, GPs.",
    bt2_17_0: "",
    bt2_17: "DDP-Ortho",
    bt2_18:
      " software is CE-certified, multilingual and available for Windows and Mac Os X. Lifetime free license opens unlimited possibilities of digital patient file creation. Free technical support makes it easy to start. Dedicated lab service makes it easy to work with.",
    st3_0: "Free, universal DICOM viewer.",
    st3_1: "Implant drill-guide and surgery wafer planning.",
    st3_2: "Volumetric air ways analysis.",


    section_title_0: 'DDS-Pro Software',
    title3_0: 'CE certified software for specialists.',
    title3_1: 'Implant treatment (drill-guide) planning. Surgery procedure (wafer) planning.',
    title3_2: 'Free, universal DICOM viewer.',
    st3_3: "CE certified.",
    bt3_0_0: "",
    bt3_0: "DDS-Pro",
    bt3_1:
      "software is dedicated for implantologists and surgeons. Offers easy way of implants placement planning and surgery procedure preparation.",
    bt3_2: "Main features:",
    bt3_3: "advanced free DICOM viewer,",
    bt3_4: "DICOM filtering and 3D object generator,",
    bt3_5:
      "complete patient digital file (pictures, cephalometry analysis, free measurements),",
    bt3_6: "editable implant database,",
    bt3_7: "implant placement planning with drill guide designer,",
    bt3_8: "universal surgery procedure planner and wafer builder,",
    bt3_9: "wax-up and digital smile design tools,",
    bt3_10: "air ways analysis with 3D visualization,",
    bt3_11_0: "compatible with, ",
    bt3_11_1: "DDP-Ortho",
    bt3_11_2: " model system.",
    bt3_12: "DDS-Pro ",
    bt3_13:
      "software is CE-certified, multilingual and available for Windows and Mac Os X. Lifetime free Viewer license granted immediately after registration. Enhanced Professional license available from on-line shop. Pay-per-use payment system guarantees minimal cost. Free technical support and dedicated lab service makes it comfortable for the doctor to work with DDS-Pro.",
    bt3_14: "DDS-pro ",
    bt3_15: "comfortable. ",

    st4_0: "Management system",
    st4_1: "for dental practicies.",
    st4_2: "Orthodonic diagnostic tools.",
    st4_3: "Data in the cloud.",
    st4_4: "Diagnostic tools.",
    st4_5: "Calendar, dicom viewer.",

    bt4_0: "Ortonet",
    bt4_1:
      " is a practice management system dedicated to orthodonic practicies. Ortonet incorporates solutions typical for programs with specialized diagnostic tools.",


    section_title_4: 'Ortonet Software',
    title4_0: 'Managment system for dental / orthodontic practises.',
    title4_1: 'Patients database, Calendar, CRM Orthodontic / dental card, diagnostics.',
    title4_2: 'Data stored in the cloud.',
    bt4_2: "The features:",
    bt4_3_0: "diagnostic tools based on",
    bt4_3_1: " DDP-Ortho ",
    bt4_3_2: "models system,",
    bt4_4: "built-in DICOM viewer,",
    bt4_5: "advanced documents administration,",
    bt4_6: "task delegation system,",
    bt4_7: "easy patient file management and data acces through the cloud makes,",
    bt4_8: ".stl file viewer,",
    bt4_8_1: "Ortonet",
    bt4_8_2: " very special compared to other software of the kind,",
    bt4_11: "full compliance with the requirements of Electronic Medical Records (reporting events to the P1 bus, document repository).",
    bt4_9: "Ortonet ",
    bt4_10:
      "is available for Windows OS, multilingual with many options of licensing.",
    st5_0: "Software for technicians and dentists. ",
    st5_1: "Virtual model creation from any source.",
    st5_2: "Indirect bonding jigs and aligner planning. ",
    st5_3: "Preparation for 3D printing.",


    section_title_3: 'DTS Software',
    title5_0: 'Software for technicians and dentists.',
    title5_1: 'Virtual model creation from any source.',
    title5_2: 'Indirect bonding splints, aligner planning.',
    bt5_0: "Digital Technical Studio",
    bt5_1:
      " is a set of tools allowing to process digital data to achieve outcomes that are usable for dentists.",
    bt5_2: " DTS ",
    bt5_3:
      "is an alternative for expensive and overcomplicated software. Provides easy-to-use tools tailored to your needs without unnecessary complications. Independently operating ",
    bt5_4: "DTS ",
    bt5_5: " modules enable implementation of separate tasks:",
    bt5_6: "processing raw data from 3D scanner,",
    bt5_7: "models preparation for 3D printing,",
    bt5_8_0: "",
    bt5_8_1: " DDP-Ortho ",
    bt5_8_2: "diagnostic models build up,",
    bt5_9: "indirect bracket bonding splints (IPA) design,",
    bt5_10: "generating series of working models for aligner treatment.",
    bt5_11: "Digital Technical Studio",
    bt5_12:
      " makes the practicies independent from global digital labs. DTS can be used in-house by a digital assistant or by cooperating local technician. Free evaluation license gives the opportunity to check the software before final decision. Pay-per-use payment system guarantees minimal cost. Each module can be purchased and used separately. Free technical support facilitates the implementation.",
    bt5_13_0: 'From RAW',
    bt5_13_1: 'Intra-oral',
    bt5_13_2: 'scan',
    bt5_14_0: 'to usable .stl',
    bt5_14_1: 'and 3D printing',
    bt5_15_0: 'Diagnostic Model',
    bt5_15_1: 'production',
    bt5_16: 'Basic',
    bt5_17: 'SemiPro',
    bt5_18_0: 'Aligners and IPA',
    bt5_18_1: 'Planing and Production',

    submit: "Submit",
    st6_0: 'Digital ',
    st6_1: 'indirect brackets',
    st6_2: 'bonding trays ',
    st6_3: 'system.',
    st6_4: 'Extremely accurate.',
    st6_5: 'Efficient.',

    section_title_5: 'Indirect Bonding Trays System IPA',
    title6_0: 'Indirect Bonding Trays System.',
    title6_1: 'Digital',
    title6_2: 'Extremly accurate.',
    title6_3: 'Highly efficient.',
    bt6_0: 'IPA ',
    bt6_1: 'is an indirect bracket bonding system developed with highest quality demand. It is compatible with ',
    bt6_2: ' virtual diagnostic model system and allows to almost fully automate bracket placement. Pre-planned bracket positioning is perfectly transferred to patient’s teeth.',
    bt6_3: 'IPA offers:',
    bt6_4: '3D visualization of real brackets, ',
    bt6_5: 'automatic virtual bracket placement according to specific bracket system’s parameters and clinical conditions,',
    bt6_6: 'bracket positions adjustment according to the doctor’s plan, ',
    bt6_7: 'shape of the jigs allows free access to bracket’s bases during application and comfortable curing.',
    bt6_8_0: '',
    bt6_8: 'is one of the ',
    bt6_9: ' software tool.',
    bt6_10: 'IPA is available as lab service or can be designed with the use of ',
    bt6_11: 'software.',

    st7_0: 'Digital aligner',
    st7_1: 'planning and production',
    st7_2: 'system for labs',
    st7_3: 'and practices.',


    section_title_6: 'Digital A-ligner system',
    title7_0: 'A complete, fully customizable',
    title7_1: 'digital system for aligner planning and production.',
    title7_2: '',
    title7_3: 'system for labs and practices',
    bt7_0: 'A-Ligner ',
    bt7_1: 'is a fully digital planning and production system. It is compatible with ',
    bt7_2: ' virtual diagnostic models system and allows to prepare aligner treatment with many options like individualized teeth movements, attachments and elastics.',
    bt7_3: 'A-Ligner system specification:',
    bt7_4: "very deep customization of the splint (range, movement and rotation, attachements shapes, sequence of teet movement, etc.), ",
    bt7_5: "optional set-up by the doctor without waiting for technician's input,",
    bt7_6: 'full procedure can be done "in-house" by the doctor himself or by local technician, ',
    bt7_7: 'each 5th splint is a very high quality "Retainer for life" just in case of brake in treatment process,',
    bt7_8: 'the splints are sent in short series (up to 5/5) to avoid problems with splints they not fitting in mouth,',
    bt7_9: 'payment for delivered splints only (instead of full price up front).',
    bt7_10: 'Working models preparation is available in ',
    bt7_11_0: '',
    bt7_11: 'is one of the ',
    bt7_12: ' software tools',
    ShowMore: "More information",
    Download: "Download ",
    ContactUs: "Contact Us",
    Close: 'Close',
    GoToTop: 'Go to top',
    Email: 'Email',
    Password: 'Password',
    Login: 'Log In',
    ResetPassword: 'Reset password',
    GoBack: 'Go back',
    SendPassword: 'SendPassword',

    // contact element
    FillAllFields: 'Please, fill all fields',
    Error: 'Internal Server Error',
    MessageSend: 'Message send',
    ServerErrorEmail: 'Server Error. Please send message to support@dds-pro.com.pl',
    FirstName: 'FirstName',
    LastName: 'LastName',
    SelectTopic: 'Select Topic',
    Technical: 'Technical',
    General: 'General',
    Business: 'Business',
    HowWeCanHelp: 'How we can help?',
    SendCopy: 'Send me a copy',

    st8_0: 'Treatment monitoring system.',
    st8_1: 'Remote access by the',
    st8_2: 'mobile application.',
    st8_3: 'Practicies search engine.',

    section_title_8: 'helo remote dental',
    section_title_8_1: 'monitoring system',
    title8_0: 'Remote orthodontic treatment monitoring system by patient\'s mobile application.',
    title8_1: 'Available practicies search engine.',

    bt8_0: 'helo',
    bt8_1: 'system opens brand new possibilities. Mobile helo application synchronized with patient\'s account in Ortonet destktop application saves time and makes contact with doctor easier. Significantly reduces the number of personal appointments in the practice.',
    bt8_2: 'The features:',
    bt8_3_0: 'sending customized notes directly to the patient by the mobile application helo ',
    bt8_3_1: 'remote polls and questions,',
    bt8_3_2: 'taking of control photos by the patient and sending them to the practice,',
    bt8_3_3: 'easy  control of the progress of treatment compared to the plan,',
    bt8_3_4: 'on-line chat.',
    bt8_4: 'Before connecting to the patient\'s account, the ',
    bt8_4_0: 'helo',
    bt8_4_1: ' app acts as a search engine for  practicies. Free ',
    bt8_4_2: 'helo',
    bt8_4_3: ' moblie application available for iPhone and Android users.',
  }
};

export const pl = {
  translations: {
    title0_1: "Witamy w ",
    title0_2: "",
    title0_3: "świecie przemysłu 4.0",
    checkOurOffer0_1: "Sprawdź naszą ",
    checkOurOffer0_2: "ofertę",
    checkOurOffer0_3: " poniżej.",

    st1_0_title_1: `Wirtualne`,
    st1_0_title_2: `Modele Diagnostyczne`,
    st1_0: "Uniwersalny system modeli dla lekarzy ortodontów.",
    st1_1: `W pełni zgodny ze wszystkimi skanerami wewnątrzustnymi.\n`,
    st1_2: "",
    st1_3: "Platforma do dalszego przetwarzania CAD/CAM.",


    section_title_2: 'Cyfrowe modele diagnostyczne',
    title1_0: 'System wirtualnych modeli diagnostycznych dla stomatologów. Modele zawierają informacje o pacjencie. ',
    title1_1: 'Dostępne są trzy typy modeli używane w zależności od potrzeb.',
    bt1_0_0: "System modeli diagnostycznych ",
    bt1_0: "DDP-Ortho",
    bt1_1:
      " umożliwia przechowywanie diagnostyki i innych ważnych informacji o pacjencie w jednym miejscu - wewnątrz pliku z modelem.",
    bt1_2: "",
    bt1_3: "Podczas przygotowania modelu technik oznacza detale anatomiczne, co umożliwia automatyzację wielu procedur; m.in. analiz modeli dostępnych natychmiast po wczytaniu modelu do oprogramowania ",
    bt1_4: "DDP-Ortho.",
    bt1_5:
      "",

    bt1_6: "Model Basic: zawiera analizy modeli, cefalo, notatki, zdjęcia, pomiary i stanowi kompletną dokumentację cyfrową przypadku.",
    bt1_7: "Model SemiPro: zawiera funkcjonalność wersji Basic, rozszerzoną o wirtualny setup.",
    bt1_8: "Model Pro: zawiera funkcjonalność wersji SemiPro, rozszerzoną o odwzorowanie rzeczywistych kształtów korzeni zębów pobrane z pliku DICOM (tomografia).",
    
    bt1_9: "Do użycia modeli wymagana jest bezpłatna aplikacja ",
    bt1_10: "DDP-Ortho",
    bt1_11: ". System jest zgodny z oprogramowaniem dla chirurgów i implantologów ",
    bt1_12: "DDS-Pro ",
    bt1_13: " oraz systemem do zarządzania pracą praktyki ",
    bt1_14: "Ortonet",
    bt1_14_1: ".",
    bt1_15_0: "Najważniejsze cele stosowania modeli ",
    bt1_15: "DDP-Ortho",
    bt1_16: ":",
    bt1_17: "tworzenie diagnostycznej dokumentacji cyfrowej pacjenta,",
    bt1_18: "planowanie i wizualizacja celów leczenia (set-up 3D - ortodoncja),",
    bt1_19: "projektowanie pozycji zamków ortodontycznych,",
    bt1_20: "przygotowanie planu leczenia nakładkowego,",
    bt1_21: "planowanie leczenia chirurgicznego, implantologicznego.",
    bt1_22_1: "",
    bt1_22: "Źródłem danych do produkcji modeli są skany wewnątrzustne lub wyciski / modele dostarczone do skanowania w pracowni technicznej.",
    bt1_23_0: "Modele ",
    bt1_23_1: "DDP-Ortho",
    bt1_23: "mogą być przygotowane w ramach zlecenia w laboratorium lub bezpośrednio przez lekarza albo technika przy użyciu oprogramowania DTS.",


    section_title_1: 'Oprogramowanie DDP-Ortho',
    title2_0: 'Bezpłatne, certyfikowane medycznie CE oprogramowanie dla specjalistów ortodontów.',
    title2_1: 'Obejmuje cyfrową dokumentację pacjenta, automatyczną analizę modeli, cefalometrię, wirtualny set-up, wizualizację celów leczenia, planowanie leczenia nakładkowego i pośrednią metodę naklejania zamków ortodontycznych.',
    title2_2: '',
    st2_0: "Bezpłatne, certyfikowane medycznie CE oprogramowanie dla ortodontów.",
    st2_1: "Kompletna diagnostyka i dokumentacja cyfrowa pacjenta.",
    st2_2: "Automatyczne wyliczanie analiz modeli, indywidualizowane analizy cefalo, wirtualny set-up, planowanie leczenia nakładkowego.",
    st2_3: "",
    bt2_0: "DDP-Ortho",
    bt2_1: " stanowi kompletne rozwiązanie dla praktyk ortodontycznych, w którym dostępne są wszystkie elementy dokumentacji.",
    bt2_2: "",
    bt2_3: "Oprogramowanie pracuje z modelami zapisanymi w formacie DDP-Ortho.  Główne funkcjonalności:",
    bt2_4: "",
    bt2_5: "",
    bt2_6: "automatyczna analiza modeli,",
    bt2_7: "dowolne pomiary,",
    bt2_8: "dołączanie i edycja zdjęć,",
    bt2_9: "notatki tekstowe,",
    bt2_10: "wirtualny set-up z wieloma opcjami wizualizacji,",
    bt2_11: "wirtualny artykulator,",
    bt2_12: "analizy cefalometryczne z wbudowanym edytorem.",
    bt2_13: "powiązane serwisy związane ze wsparciem leczenia:",
    bt2_14: "planowanie położenia zamków z pośrednią metodą klejenia,",
    bt2_15: "kompletne rozwiązanie dla planowania i realizacji leczenia nakładkowego,",
    bt2_16: "platforma wymiany informacji między specjalistami (ortodonta, stomatolog, protetyk, chirurg).",
    bt2_17_0: "Oprogramowanie ",
    bt2_17: "DDP-Ortho",
    bt2_18:
      " posiada certyfikację medyczną CE, jest wielojęzyczne, dostępne na system operacyjny Windows oraz Mac OS X. Dożywotnia bezpłatna licencja obejmuje także kolejne aktualizacje. DDP-Ortho objęte jest bezpłatnym wsparciem technicznym i pomocą we wdrożeniu do pracy w gabinecie.",
    
    
    
    st3_0: "Bezpłatna, uniwersalna przeglądarka plików DICOM.",
    st3_1: "Planowanie szablonów implantologicznych oraz pośrednich szyn operacyjnych.",
    st3_2: "Analiza objętościowa dróg oddechowych.",
    
    section_title_0: 'Oprogramowanie DDS-Pro',
    title3_0: '',
    title3_1: 'Planowanie szablonów implantologicznych oraz pośrednich szyn operacyjnych.',
    title3_2: 'Zawiera bezpłatną uniwersalną przeglądarkę plików DICOM.',
    st3_3: "Oprogramowanie certyfikowane medycznie CE.",
    bt3_0_0: "Oprogramowanie ",
    bt3_0: "DDS-Pro",
    bt3_1:
      " adresowane jest do lekarzy specjalistów. Obejmuje projektowanie i wykonywanie szablonów chirurgicznych oraz pośrednich szyn operacyjnych.",
    bt3_2: "Najważniejsze funkcje oprogramowania DDS-Pro:",
    bt3_3: "zaawansowane przeglądanie plików DICOM,",
    bt3_4: "filtrowanie i generowanie 3D struktur z plików DICOM,",
    bt3_5:
      "tworzenie dokumentacji pacjenta (zdjęcia, analizy cefalo, pomiary),",
    bt3_6: "budowanie własnej edytowalnej biblioteki implantów,",
    bt3_7: "planowanie pozycji implantów wraz z generowaniem szablonu chirurgicznego,",
    bt3_8: "planowanie i symulacja wyników zabiegów chirurgicznych wraz z szynami do zabiegów,",
    bt3_9: "narzędzie do cyfrowego projektowania uśmiechu z wax-up'em,",
    bt3_10: "wolumetryczna analiza 3D dróg oddechowych,",
    bt3_11_0: "oprogramowanie zgodne z modelami w standardzie ",
    bt3_11_1: "DDP-Ortho.",
    bt3_11_2: "",

    bt3_12: "DDS-Pro ",
    bt3_13:
      " jest certyfikowane medycznie CE, zawiera wiele wersji językowych interfejsu, pracuje na platformie Windows oraz MacOS X. Bezpośrednio po bezpłatnej rejestracji i uzyskaniu dożywotniej licencji Viewer może być używane jako zaawansowana przeglądarka plików DICOM. Rozszerzona licencja Professional jest dostępna do nabycia w sklepie on-line. Koszty używania ograniczone są do minimum zgodnie z zasadą pay-per-use (bez żadnych stałych opłat). Komfortowa praca gwarantowana jest przez bezpłatną pomoc techniczną oraz dedykowany serwis laboratoryjny.",
    bt3_14: "DDS-pro ",
    bt3_15: "comfortable. ",


    st4_0: "Kompletne zarządzanie",
    st4_1: "praktyką stomatologiczną.",
    st4_2: "Dane w chmurze.",
    st4_3: "Narzędzia diagnostyki ortodontycznej.",
    st4_4: "Kalendarz, przeglądarka DICOM.",
    st4_5: "",

    st4_0_1: "Management system for",
    st4_0_2: "dental / orthodontic practices.",
    bt4_0: "Ortonet",
    bt4_1:
      " jest oprogramowaniem dedykowanym dla praktyk ortodontycznych i stomatologicznych - zawiera typowe funkcjonalności oraz zaawansowane specjalistyczne narzędzia diagnostyczne 3D.",


    section_title_4: 'Oprogramowanie Ortonet',
    title4_0: 'Kompletny system do zarządzania praktyką ortodontyczną i stomatologiczną.',
    title4_1: 'Obejmuje bazę danych pacjentów, analizy diagnostyczne, kalendarz, CRM, delegowanie zadań i wiele innych funkcji.',
    title4_2: 'Dane są składowane w chmurze.',
    bt4_2: "Wybrane funkcje:",
    bt4_3_0: "narzędzia diagnostyczne bazujące na standardzie ",
    bt4_3_1: "DDP-Ortho",
    bt4_3_2: ",",
    bt4_4: "wbudowana przeglądarka plików DICOM,",
    bt4_5: "zaawansowane administrowanie dokumentacją,",
    bt4_6: "system delegowania zadań,",
    bt4_7: "proste zarządzanie danymi pacjenta z dostępem z dowolnego miejsca (chmura),",
    bt4_8: "przeglądarka plików .stl,",
    bt4_8_0: "",
    bt4_8_1: "",
    bt4_8_2: "",
    bt4_11: "pełna zgodność z wymogami Elektronicznej Dokumentacji Medycznej (raportowanie zdarzeń do szyny P1, repozytorium dokumentów).",
    bt4_9: "Ortonet",
    bt4_10:
      " pracuje na platformie Windows, jest wielojęzyczne, oferta zawiera kilka wariantów licencjonowania.",
    st5_0: "Oprogramowanie dla lekarzy i techników.",
    st5_1: "Tworzenie wirtualnych modeli diagnostycznych z wielu źródeł danych.",
    st5_2: "Projektowanie nakładek, szyn do klejenia pośredniego zamków,",
    st5_3: "przygotowywanie modeli do wydruków 3D.",


    section_title_3: 'Oprogramowanie DTS	',
    title5_0: 'Oprogramowanie dla techników i stomatologów.',
    title5_1: 'Pozwala na tworzenie modelu wirtualnego z dowolnego źródła,',
    title5_2: 'przygotowanie leczenia nakładkowego oraz klejenie pośrednie zamków ortodontycznych.',
    bt5_0_0: "Oprogramowanie ",
    bt5_0: "DTS - Digital Technical Studio",
    bt5_1:
      " - oprogramowanie dla techników, punktów usługowych drukowania 3D, asystentów cyfrowych lub klinicystów. Jest alternatywą do drogich i nadmiernie rozbudowanych programów specjalistycznych. Dostarcza narzędzi łatwych w użyciu, podzielonych na moduły i pozbawionych zbędnych komplikacji. Każdy moduł może działać jako wybrane niezależne narzędzie:",
    bt5_2: "",
    bt5_3: "",
    bt5_4: "",
    bt5_5: "",
    bt5_6_0: 'Dental Model Builder (DMB) ',
    bt5_6: "- do tworzenia modelu diagnostycznego: od nieprzetworzonego skanu pliku do gotowego do wydruku modelu 3D.",
    bt5_7_0: 'Diagnostic Model Editor (DME) ',
    bt5_7: " - do tworzenia modeli diagnostycznych 3D z możliwością Set-Up'u.",
    bt5_8_0_0: 'Indirect Bracket Placement ',
    bt5_8_0: "(IPA - Indywidualnie Projektowane Aparaty) - do projektowania szyn (jigs lub płytki termoformowalne) do pośredniej metody klejenia zamków.",
    bt5_8_1: "Aligners Planner (AP)",
    bt5_8_2: " - do projektowania leczenia alignerami.",
    bt5_9: "",
    bt5_10: "",
    bt5_11: "Digital Technical Studio",
    bt5_12:
      "  pozwala praktyce na samodzielną pracę. Może być użyty przez cyfrowego asystenta lub lekarza bezpośrednio w gabinecie. Jest też narzędziem dla współpracującego laboratorium. Bezpłatna licencja testowa umożliwia wypróbowanie oprogramowania przed zakupem. Optymalny system płatności bez stałych kosztów (pay-per-use) gwarantuje najniższy koszt użycia. Każdy moduł może być zakupiony i używany niezależnie. Bezpłatne wsparcie techniczne znakomicie ułatwia łatwe wdrożenie do pracy.",
    bt5_13_0: 'Od nieprzetworzonego',
    bt5_13_1: 'pliku ze skanera',
    bt5_13_2: 'wewnątrzustnego',
    bt5_14_0: 'do użytecznego pliku .stl',
    bt5_14_1: 'oraz wydruków 3D',
    bt5_15_0: 'Produkcja modeli',
    bt5_15_1: 'diagnostycznych',
    bt5_16: 'Basic',
    bt5_17: 'SemiPro',
    bt5_18_0: 'Projektowanie i produkcja',
    bt5_18_1: 'alignerów i IPA',




    submit: "Prześlij",
    st6_0: `Precyzyjny i efektywny w użyciu cyfrowy system `,
    st6_1: `transferów do 
    pośredniego klejenia 
    zamków. `,
    st6_2: '',
    st6_3: '',
    st6_4: '',
    st6_5: '',


    section_title_5: 'Pośrednie naklejanie zamków',
    title6_0: 'IPA (Indywidualnie Projektowane Aparaty)',
    title6_1: '',
    title6_2: 'Precyzyjna i efektywna w użyciu cyfrowa technika transferów do zamków ortodontycznych.',
    title6_3: '',
    bt6_0: 'IPA',
    bt6_1: ' jest techniką przygotowaną dla najbardziej wymagających lekarzy. Zgodność z modelami ',
    bt6_2: ' zapewnia automatyczne pozycjonowanie zamków na zębach z możliwością dopozycjonowania przez lekarza. Zaplanowane położenie zamków jest perfekcyjnie przenoszone na zęby pacjenta.',
    bt6_3: 'Funkcjonalności techniki IPA:',
    bt6_4: 'wizualizacja 3D zamków,',
    bt6_5: 'automatyczne pozycjonowanie zamków dopasowane do przypadku,',
    bt6_6: 'dopasowanie pozycji zamków przez lekarza zgodnie z preferencjami i planem leczenia,',
    bt6_7: 'swobodny dostęp do podstawy zamka dla niezawodnej polimeryzacji.',
    bt6_8_0: 'Technika ',
    bt6_8: ' jest jedną z funkcjonalności oprogramowania ',
    bt6_9: '.',
    bt6_10: 'Jest dostępna jako zewnętrzny serwis laboratoryjny lub do samodzielnego przygotowania w gabinecie z zastosowaniem oprogramowania',
    bt6_11: '.',

    st7_0: 'Cyfrowy system',
    st7_1: 'projektowania i produkcji nakładek',
    st7_2: 'dla laboratoriów',
    st7_3: 'i praktyk lekarskich.',


    section_title_6: 'Cyfrowy system A-ligner	',
    title7_0: 'Kompletny w pełni indywidualizowany cyfrowy system do planowania i produkcji alignerów.',
    title7_1: '',
    title7_2: '',
    title7_3: '',
    bt7_0: 'A-Ligner',
    bt7_1: ' jest cyfrowym systemem opartym na wirtualnych modelach diagnostycznych  ',
    bt7_2: ' Umożliwia planowanie leczenia nakładkowego z pełną kontrolą przesunięć zębów (szybkość, kolejność), stosowaniem zaczepów, elastików, itd.',
    bt7_3: 'Specyfikacja systemu:',
    bt7_4: "pełna indywidualizacja projektowanych nakładek (wartości przemieszczeń i rotacji zębów, kształt zaczepów, sekwencje ruchów, elementy dodatkowe),",
    bt7_5: "edytowalny set-up dostępny bez kontaktu z technikiem,",
    bt7_6: 'cały proces planowania i produkcji może odbywać się w praktyce lub wskazanej pracowni,',
    bt7_7: 'zalecane stosowanie "Retainer For Life" czyli przygotowanie każdej 5tej nakładki w serii jako retainera możliwego do długotrwałego użycia na wypadek losowego przerwania leczenia,',
    bt7_8: 'nakładki dostarczane są w krótkich seriach po 5 szt., co eliminuje problem niedopasowania nakładek w długich seriach dostarczanych z góry,',
    bt7_9: 'elastyczne płatności etapami za dostarczane serie nakładek, bez konieczności opłacania za całe leczenie z góry.',
    bt7_11_0: 'System ',
    bt7_11: ' jest obsługiwany w ramach bezpłatnego oprogramowania',
    bt7_12: '.',

    bt7_10: 'Przygotowanie serii modeli roboczych do produkcji nakładek realizuje oprogramowanie',



    ShowMore: "Więcej informacji znajdziesz tutaj.",
    Download: "Pobierz ",
    ContactUs: "Kontakt",
    Close: 'Zamknij',
    GoToTop: 'Powrót',
    Email: 'Email',
    Password: 'Hasło',
    Login: 'Login',
    ResetPassword: 'Przywracanie hasła',
    GoBack: 'Powrót',
    SendPassword: 'Wyślij hasło',

    // contact element
    FillAllFields: 'Prosze wypełnić wszystkie pola',
    Error: 'Błąd serwera',
    MessageSend: 'Wiadomość wysłana',
    ServerErrorEmail: 'Błąd serwera. Prosze wysłać wiadomość na support@dds-pro.com.pl',
    FirstName: 'Imię',
    LastName: 'Nazwisko',
    SelectTopic: 'Wybierz temat',
    Technical: 'Techniczny',
    General: 'Ogólny',
    Business: 'Business',
    HowWeCanHelp: 'Jak możemy pomóc?',
    SendCopy: 'Wyślij mi kopie',

    st8_0: 'System komunikacji z pacjentem.',
    st8_1: 'Zdalny dostęp poprzez aplikację.',
    st8_2: 'Wyszukiwarka praktyk.',
    st8_3: '',

    section_title_8: 'helo - zdalne monitorowanie leczenia',
    section_title_8_1: '',
    title8_0: 'Zdalny system do monitorowania leczenia ortodontycznego przy pomocy aplikacji moblilnej pacjenta.',
    title8_1: 'Wbudowana wyszukiwarka praktyk.',

    bt8_0: 'System helo',
    bt8_1: 'oferuje zupełnie nowe możliwości. Aplikacja  sparowana z kontem pacjenta w aplikacji Ortonet oszczędza czas i upraszcza komunikację z lekarzem. Zmniejsza ilość wizyt osobistych.',
    bt8_2: 'Wybrane funkcje:',
    bt8_3_0: 'przesyłanie pacjentowi dopasowanych wskazówek, ',
    bt8_3_1: 'zdalne ankiety,',
    bt8_3_2: 'samodzielne wykonywanie zdjęć kontrolnych przez pacjenta,',
    bt8_3_3: 'łatwa kontrola postępów leczenia w porównaniu z planem,',
    bt8_3_4: 'czat on-line.',
    bt8_4: 'Przed połączeniem z kontem pacjenta aplikacja ',
    bt8_4_0: 'helo',
    bt8_4_1: ' działa jako wyszukiwarka praktyk ortodontycznych. Bezpłatna aplikacja ',
    bt8_4_2: 'helo',
    bt8_4_3: ' dostępna jest dla użytkowników iPhona i Androida.',
  }
}